import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "auth confirm-email" }
const _hoisted_2 = {
  key: 0,
  class: "alert danger"
}
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Verification Code", -1)
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", {
  id: "verification-code-help",
  class: "form-text text-muted"
}, " The verification code has been sent to the email you supplied. ", -1)
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = { class: "col-sm-6 offset-sm-3" }
const _hoisted_9 = ["disabled"]

import { ref, computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Auth from '@aws-amplify/auth';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmEmail',
  setup(__props) {

const actProperty: any = inject('actProperty');

const store = useStore();
const router = useRouter();

// Reactive state for code and error
const code = ref('');
const error = ref('');

// Computed property for cognitoUser from Vuex store
const cognitoUser = computed(() => store.getters['auth/cognitoUser']);

// Method to confirm sign in
const confirmSignIn = async () => {
  error.value = ''; // Reset error message before the attempt

  try {
    await Auth.confirmSignIn(cognitoUser.value, code.value, 'SOFTWARE_TOKEN_MFA');
    router.push({ name: 'reports' });
  } catch (err: any) {
    actProperty.displayError(err);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (error.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "email",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event))
        }, null, 512), [
          [_vModelText, code.value]
        ]),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmSignIn())),
          disabled: !code.value.length
        }, " Confirm ", 8, _hoisted_9)
      ])
    ])
  ]))
}
}

})